let btnSignUp = document.querySelector(".btn-signup");

if (btnSignUp) {
  btnSignUp.addEventListener("click", function (e) {
    e.preventDefault();
    var newsletterForm = document.getElementById("newsletterForm");

    // Create an object to hold the data you want to send
    var data = {
      email: newsletterForm.querySelector("[name='email']").value,
      language: newsletterForm.querySelector("[name='language']").value,
    };

    if (newsletterForm.checkValidity() === true) {
      $.ajax({
        url: "/api.php?api=registerNewsletter",
        type: "GET",
        data: data,
        dataType: "html",
        success: function (response) {
          console.log(response);
        },
        error: function () {
          console.error("An error occurred.");
        },
      });
      $("#m-newsletter-signup").modal("show");
      newsletterForm.querySelector("[name='email']").value = "";
      setTimeout(function () {
        $("#m-newsletter-signup").modal("hide");
      }, 5000);
    } else {
    }
  });
}
